import React from "react";
import { Badge } from "reactstrap";
import FormatCurrency from '../../components/Common/FormatCurrency';



const Columns = ({ information, precioPasaje }) => {
  const columns = [
    {
      id: "unit",
      name: "Unidad",
      center: true,
      cell: (e) => {
        return Math.floor(e.number).toFixed(0);
      },
    },
    {
      id: "pasaje",
      name: "Pasaje Sensores",
      center: true,
      cell: (e) => {
        return Math.floor(e.pasaje).toFixed(0);
      },
    },
    {
      id: "tickets_adultos",
      name: "Tickets Adulto",
      center: true,
      cell: (e) => {
        return Math.floor(e.tickets ?? 0).toFixed(0);
      },
    },
    {
      id: "tickets_menores",
      name: "Tickets Menores",
      center: true,
      cell: (e) => {
        return Math.floor(e.tickets_menor ?? 0).toFixed(0);
      },
    },
    {
      id: "tickets_totales",
      name: "Tickets Totales",
      center: true,
      cell: (e) => {
        return (Math.floor(e.tickets ?? 0) + Math.floor(e.tickets_menor ?? 0)).toFixed(0);
      },
    },
    {
      id: "diferencia",
      name: "Diferencia",
      center: true,
      cell: (e) => {
        const valor = (e.pasaje && e.tickets) ? e.pasaje - e.tickets - e.tickets_menor : 0;
        return Math.floor(valor).toFixed(0);
      },
    },
    /*
    {
      id: "conteoTotalSubidas",
      name: "Conteo total subidas",
      minWidth: "200px",
      center: true,
      cell: (e) => {
        return 0;
      },
    },
    {
      id: "conteoTotalBajadas",
      name: "Conteo total bajadas",
      minWidth: "200px",
      center: true,
      cell: (e) => {
        return 0;
      },
    },
    */
    {
      id: "dineroTotal",
      name: "Importe Pasajes",
      right: true,
      cell: (e) =>
        <FormatCurrency className="text-end" value={((e.pasaje ?? 0) * precioPasaje).toFixed(2)} />
      ,
    },
    {
      id: "dineroTotalTickets",
      name: "Importe Tickets",
      right: true,
      cell: (e) =>
        <FormatCurrency className="text-end" value={(((e.tickets ?? 0) + (e.tickets_menor ?? 0)) * precioPasaje).toFixed(2)} />
      ,
    },
    {
      id: "actions",
      name: "Acciones",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="pe-2">
            <button
              className="btn btn-primary btn-sm"
              title="Duplicar"
              onClick={() => information(row)}
            >
              <i className="fa fa-info"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];
  return columns;
};

export default Columns;

//vaneton beicli
